import { ImageThumbnailRatio } from "@components/ImageThumbnailRatio";
import VnrLink from "@components/VnrLink";
import { Col, Row } from "antd";
import React from "react"

import TitleSection from "../TitleSection";
import styles from "./Topic.module.scss";

const Topic = ({ topics }) => {
  const TopicItem = ({ topic }) => {
    return (
      <VnrLink className={styles.topicItem} to={topic.path}>
        <ImageThumbnailRatio 
          src={topic.icon} 
          alt={topic.name} 
          ratio="250:90"
        />
        <div className={styles.topicBackground}> </div>
        <h3 className={styles.topicTitle}>{topic.name}</h3>
      </VnrLink>
    );
  };

  return (
    <div className={styles.vnrTopic}>
      <TitleSection title="Kiến thức theo chủ đề" link="/forex-topic" />
      <Row span={24} gutter={[25, 25]} justify="space-between">
        {topics.slice(0, 5).map((topic) => {
          return (
            <Col span={12} key={topic.id}>
              <TopicItem topic={topic.acf} />
            </Col>
          );
        })}
        {topics.slice(5, 10).map((topic) => {
          return (
            <Col span={12} key={topic.id}>
              <TopicItem topic={topic.acf} />
            </Col>
          );
        })}
      </Row>
      <div className={styles.readMorePostGroup}>
        <VnrLink
          to="/forex-topic"
          className={styles.readMoreText}
        >
          &#187; Xem tất cả
        </VnrLink>
      </div>
    </div>
  );
};
export default Topic;
